// core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// campfire
import { OpenModule } from '@campfire-nx/open';
import { MaterialModule } from '@campfire-nx/material';

// components
import { DeviceRoutingModule } from './device-routing.module';
import { DeviceValidationComponent } from './components/device-validation/device-validation.component';
import { DeviceCaptureComponent } from './components/device-capture/device-capture.component';
import { DeviceImeiComponent } from './components/device-imei/device-imei.component';


@NgModule({
  declarations: [
    DeviceValidationComponent,
    DeviceCaptureComponent,
    DeviceImeiComponent
  ],
  imports: [
    CommonModule,
    DeviceRoutingModule,
    OpenModule,
    MaterialModule
  ]
})
export class DeviceModule { }
